import { render } from "./NavEntry.vue?vue&type=template&id=76efb096"
import script from "./NavEntry.vue?vue&type=script&lang=js"
export * from "./NavEntry.vue?vue&type=script&lang=js"
script.render = render

export default script